/* eslint-disable no-unused-vars */
import { useRef, useCallback } from 'react';
import { Buttons, DropDownWrapper, MenuItem } from 'components';
import { useSignal, useComputed } from '@preact/signals-react';
import { Filter as FilterIcon, ArrowDown } from 'assets/icons';
import * as S from './FilterBtn_v2.styled';
import { FilterContent } from './FilterContent';
import { saveLocalStorageItem, getLocalStorageItem } from 'utils';

export const FilterBnt_v2 = ({ selectedStatusFilter$ }) => {
  const currentFilter$ = useSignal('campaignStatus');

  const filterBtnIsPressed$ = useSignal(false);
  const btnRef = useRef(null);
  const targetRef = useRef(null);
  const width$ = useSignal(180 + 220);

  const menuClick = useCallback((value, additionalWidth) => {
    currentFilter$.value = value;
    width$.value = 172 + additionalWidth;
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <div>
        <Buttons.TertiarySmall
          ref={btnRef}
          isPressed={filterBtnIsPressed$.value}
          onClick={(e) => {
            filterBtnIsPressed$.value = !filterBtnIsPressed$.value;
          }}
        >
          Filter
        </Buttons.TertiarySmall>
      </div>
      {useComputed(() => (
        <>
          {filterBtnIsPressed$.value && (
            <DropDownWrapper
              isOpen$={filterBtnIsPressed$}
              width={width$.value}
              targetRef={targetRef}
              style={{ left: '-300px', top: '45px' }}
              outSideClickAction={() => menuClick('campaignStatus', 228)}
            >
              <S.Container>
                <S.MenuItemsContainer>
                  <MenuItem
                    value='campaignStatus'
                    onClick={(value) => menuClick(value, 228)}
                    height={40}
                    isSelected={currentFilter$.value === 'campaignStatus'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'campaignStatus'}>
                      Campaign Status <ArrowDown />
                    </S.Title>
                  </MenuItem>
                  <MenuItem
                    onClick={(value) => {
                      menuClick(value, 264);
                    }}
                    value='targetedGeos'
                    height={40}
                    isSelected={currentFilter$.value === 'targetedGeos'}
                  >
                    <S.Title isHidden={currentFilter$.value === 'targetedGeos'}>
                      Targeted Geos <ArrowDown />
                    </S.Title>
                  </MenuItem>
                </S.MenuItemsContainer>
                <FilterContent.CampaignStatus
                  isShow={currentFilter$.value === 'campaignStatus'}
                  selectedStatusFilter$={selectedStatusFilter$}
                />
                {/* <FilterContent.TargetedGeos
                  isShow={currentFilter$.value === 'targetedGeos'}
                  isOpen$={filterBtnIsPressed$}
                  menuClick={menuClick}
                /> */}
              </S.Container>
            </DropDownWrapper>
          )}
        </>
      ))}
    </div>
  );
};
